import { createBrowserRouter } from 'react-router-dom';
import App from '../../App';
import PageNotFound from '../../PageNotFound';
import Login from '../onboarding/Login';
import TemplateLoader from '../../TemplateLoader';

import ManagerDriverDetail from '../manager/ManagerDriverDetail';
import ManagerDriverIncidentDetail from '../common/IncidentDetail';
import ManagerMissedAcknowledgments from '../manager/ManaagerMissedAcknowledgments';
import { ReactNode } from 'react';
import NavBarWrapper from '../common/NavBarWrapper';
import IncidentDetail from '../common/IncidentDetail';
import About from '../common/About';

export enum Paths {
	HOME = '/',
	MOBILE = '/mobile',
	LOGIN = '/login',
	DRIVER_INCIDENT_DETAIL = '/driver/incident/:name',
	MANAGER_DRIVER_DETAIL = '/manager/group/:groupid/driver/:id',
	MANAGER_DRIVER_INCIDENT_DETAIL = '/manager/group/:groupid/driver/:id/incident/:name',
	MANAGER_MISSED_ACKNOWLEDGMENTS = '/manager/group/:groupid/missed_acknowledgments',
	TEMPLATES = 'templates',
	PROTOCOL_HANDLER = '/home/*',
	ABOUT = '/about',

}


function Wrapper(element:ReactNode, title:string, isHome:boolean) {

	return(
		<div>
			<NavBarWrapper title={title} isHome={isHome}>
				{ element}
			</NavBarWrapper>
			
		</div>
	)
}

export const router = createBrowserRouter([
	{
		path: Paths.HOME,
		element: Wrapper(<App />, "Dashboard", true),
		errorElement: <PageNotFound />
	},
	{
		path: Paths.MOBILE,
		element: Wrapper(<App />, "Dashboard", true),
		errorElement: <PageNotFound />
	},
	{
		path: `${Paths.LOGIN}/*`,
		element: <Login />,
		errorElement: <PageNotFound />
	},
	{
		path: Paths.DRIVER_INCIDENT_DETAIL,
		element: Wrapper(<IncidentDetail />, "Dashboard", false),
		errorElement: <PageNotFound />
	},
	{
		path: Paths.TEMPLATES,
		element: <TemplateLoader />,
		errorElement: <PageNotFound />
	},
	{
		path: Paths.MANAGER_DRIVER_DETAIL,
		element: Wrapper(<ManagerDriverDetail />, "Dashboard", false),
		errorElement: <PageNotFound />
	},
	{
		path: Paths.MANAGER_DRIVER_INCIDENT_DETAIL,
		element: Wrapper(<ManagerDriverIncidentDetail />, "Driver Detail", false),
		errorElement: <PageNotFound />
	},
	{
		path: Paths.MANAGER_MISSED_ACKNOWLEDGMENTS,
		element: Wrapper(<ManagerMissedAcknowledgments />, "Missed Acknowledgments", true),
		errorElement: <PageNotFound />
	},
	{
		path: Paths.PROTOCOL_HANDLER,
		element: Wrapper(<App />, "Dashboard", true),
		errorElement: <PageNotFound />
	},
	{
		path: Paths.ABOUT,
		element: Wrapper(<About />, "About", true),
		errorElement: <PageNotFound />
	},
], {
	future: {
		v7_startTransition: true,
	}
});